import { AppIconImpl } from "./named-icons";

const AppIcon = AppIconImpl;
export default AppIcon;
